/** @format */

import useOnClickOutside from '@common/application/hooks/useOnClickOutside/src/lib/useOnClickOutside';

export default useOnClickOutside;
